import { Node } from "@tiptap/pm/model";
import { useMemo } from "react";
import { richTextEditorDocumentJSONStringToProseMirrorNode } from "./controlledRichTextEditorMarkdown";

export function useDocumentIsMissingAltText(doc?: Node | null): boolean {
  return useMemo(() => {
    if (!doc) return false;
    let missingAltText = false;
    doc.descendants((node) => {
      if (node.type.name === "image") {
        const alt = node.attrs.alt;
        const isDecorative = node.attrs.isDecorative;
        if (!isDecorative && (!alt || alt.trim() === "")) {
          missingAltText = true;
          return false; // Stop iteration
        }
      }
      return true; // Continue iteration
    });
    return missingAltText;
  }, [doc]);
}

export function useDocumentJSONStringIsMissingAltText(jsonString?: string | null): boolean {
  const doc = useMemo(() => {
    if (!jsonString) return null;
    return richTextEditorDocumentJSONStringToProseMirrorNode(jsonString);
  }, [jsonString]);

  return useDocumentIsMissingAltText(doc);
}
